import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/services/env.config';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor( private http: HttpClient) { }
  noDataFlag: boolean = true;
  target: any;
  table_data: any[] = [];
  cpHeaders = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'
    })
  };
  ngOnInit() {
    this.getSchemeMaster();
     this.getTaskMaster();
  }


  getTaskMaster() {
    let data = JSON.parse(sessionStorage.getItem('user')) ;
    //  let user = { DealUserName : data.UserName  }; 
    let DealUserName;
    if(data.DealUserName){
     DealUserName = data.DealUserName;
    }
     let user = { UserName : data.UserName , DealUserName: DealUserName }; 
    this.http.post(Config.BaseEndpoint + '/GetDealerTarget' , JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        if(response.length > 0) {
          this.target = response;
        } 
       
      })
    .catch((error) => {
      console.log(Promise.reject(error));
    });
  }

  getSchemeMaster() {
    let data = JSON.parse(sessionStorage.getItem('user')) ;
    let DealUserName	= JSON.parse(sessionStorage.getItem('DealUserName'));
     let user = { UserName : data.UserName , DealUserName : DealUserName, ContentFlag : true }; 
    this.http.post(Config.BaseEndpoint + '/GetContent' , JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((response: any) => {
        if(response.length > 0) {
          this.table_data = response;
          for(let i = 0; i < this.table_data.length ; i ++) {
            this.table_data[i]['divStatusOpen'] = true
          }
          
          this.noDataFlag = true;
        } else {
          this.noDataFlag = false;
        }
       
      })
    .catch((error) => {
      console.log(Promise.reject(error));
    });
  }

toggleShow(index) {
  this.table_data[index]['divStatusOpen'] = !this.table_data[index]['divStatusOpen']
}

  ViewScheme(id)  {
    let data = JSON.parse(sessionStorage.getItem('user')) ;
    let user = { UserName : data.UserName , SchemeMgmtId: id } ;
    return this.http
      .post(Config.BaseEndpoint + '/DownloadFile', JSON.stringify(user), this.cpHeaders)
      .toPromise()
      .then((data: any) => {
        if (data.FileData) {
            // Download PDF in Chrome etc.
            const source = `data:application/pdf;base64,${data.FileData}`;
            const link = document.createElement("a");
            link.href = source;
            link.download = `${data.FileName}.pdf`
            link.click();
        
        }
       
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

}
